import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, MapPin, Phone, Mail } from 'lucide-react';
export function FooterCTA() {
  const whatsappUrl = 'https://wa.me/573182434499?text=Hola%20Gerfaj%2C%20vi%20su%20p%C3%A1gina%20de%20Reformas%2C%20quiero%20conversar%20acerca%20de%20lo%20que%20tengo%20en%20mente%20';
  return <footer className="bg-gerfaj-dark pt-24 md:pt-32 pb-12 border-t border-white/5" data-id="element-55">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-56">
        <div className="text-center mb-20" data-id="element-57">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-montserrat font-bold text-white mb-6" data-id="element-58">
            ¿Hablamos de tu proyecto?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-59">
            El primer paso es{' '}
            <span className="font-bold text-gerfaj-orange" data-id="element-60">escucharte</span>.
            Queremos conocer qué tienes en mente para explicarte, de forma clara
            y sin enredos, cómo podemos hacerlo{' '}
            <span className="font-bold text-gerfaj-orange" data-id="element-61">realidad</span>.
            Tengamos una conversación honesta para que tomes la mejor decisión.
          </motion.p>

          <motion.a href={whatsappUrl} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center justify-center gap-3 bg-gerfaj-orange hover:bg-orange-600 text-white font-bold text-lg px-8 py-4 rounded-2xl cta-glow transition-all duration-300 w-[90%] sm:w-auto min-h-[60px]" data-id="element-62">
            <MessageCircle className="w-6 h-6" data-id="element-63" />
            Quiero compartir lo que tengo en mente
          </motion.a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pt-12 border-t border-white/10" data-id="element-64">
          <div className="flex flex-col items-center md:items-start" data-id="element-65">
            <div className="mb-4" data-id="element-66">
              <img src="https://cdn.magicpatterns.com/uploads/8J5rvBbaJ8KDy4mkSYfR5w/Logo-Gerfaj.png" alt="Gerfaj - Arquitectura e Ingeniería" className="h-10 w-auto brightness-0 invert" loading="lazy" decoding="async" width={200} height={40} data-id="element-67" />
            </div>
            <p className="text-gray-500 text-sm text-center md:text-left" data-id="element-68">
              Arquitectura e Ingeniería.
              <br data-id="element-69" />
              Transformando ideas en realidades tangibles desde hace 30 años.
            </p>
          </div>

          <div className="flex flex-col items-center md:items-start gap-4 text-gray-400" data-id="element-70">
            <div className="flex items-center gap-3" data-id="element-71">
              <MapPin className="w-5 h-5 text-gerfaj-orange" data-id="element-72" />
              <span data-id="element-73">Bucaramanga, Santander, Colombia</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-74">
              <Phone className="w-5 h-5 text-gerfaj-orange" data-id="element-75" />
              <span data-id="element-76">+57 318 243 4499</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-77">
              <Mail className="w-5 h-5 text-gerfaj-orange" data-id="element-78" />
              <span data-id="element-79">gerfaj.sas@gmail.com</span>
            </div>
          </div>

          <div className="flex flex-col items-center md:items-end justify-center" data-id="element-80">
            <p className="text-gray-600 text-sm text-center md:text-right" data-id="element-81">
              &copy; {new Date().getFullYear()} Gerfaj Arquitectura e
              Ingeniería.
              <br data-id="element-82" />
              Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}